export default class HeroText {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.hero-text__section'), el => {
            new HeroText(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.stickySectionTrigger = this.element.querySelector('.hero-text .hero-text-sticky-trigger');

        if (!this.stickySectionTrigger) return;
        this.stickySection = this.element.querySelector('.hero-text-sticky');

        window.addEventListener('scroll', (e) => {
            this.stickySection.classList[!this.isInViewport(this.stickySectionTrigger) ? 'add' : 'remove']('is-visible');
        });
    }

    isInViewport(el) {
        let headerHeight = document.querySelector('.header__inner').getBoundingClientRect().height;
        let switchLanguageNoticeHeight = document.body.classList.contains('body--switch-language-notice-is-visible')
            ? document.querySelector('.switch-language-notice').getBoundingClientRect().height
            : 0;
        let rect = el.getBoundingClientRect();

        return (
            rect.top >= headerHeight + switchLanguageNoticeHeight &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }
}
